import { CSSProperties } from "react";

const multiSelectStyles = {
  container: (base: CSSProperties) => ({
    ...base,
    marginBottom: 226,
    maxWidth: 264,
    minWidth: 249,
  }),
  menuList: (base: CSSProperties) => ({
    ...base,
    height: 216,
    minHeight: 216,
  }),
  multiValue: (base: CSSProperties) => ({
    ...base,
    maxWidth: 150,
  }),
  valueContainer: (base: CSSProperties) => ({
    ...base,
    maxHeight: 300,
    overflow: "auto",
    msOverflowStyle: "none",
  }),
};

export default multiSelectStyles;

export type ReactSelectStyles = typeof multiSelectStyles;
